import Misc from 'src/utils/helper/misc'
// This is validation on JSON of submission at vuex store level for edge case entering <script> tag at UI level
const validatSubmissionJSON = (userMetaData = {}, description = '') => {
  const validator = {
    binaries: () => {
      if (userMetaData.hasOwnProperty('binaries') && Array.isArray(userMetaData.binaries) && userMetaData.binaries.length > 0) {
        const isValid = userMetaData.binaries.some(item => !Misc.validateScriptRegex(item.styleName))
        return isValid
      }
    },
    customerMessage: () => {
      if (userMetaData.hasOwnProperty('customerMessage')) {
        const isValid = !Misc.validateScriptRegex(userMetaData.customerMessage)
        return isValid
      }
    },
    familyName: () => {
      if (userMetaData.hasOwnProperty('family') && Object.keys(userMetaData.family).length > 0) {
        const isValid = !Misc.validateScriptRegex(userMetaData.family.name)
        return isValid
      }
    },
    familyUniqueName: () => {
      if (userMetaData.hasOwnProperty('family') && Object.keys(userMetaData.family).length > 0) {
        const isValid = !Misc.validateScriptRegex(userMetaData.family.uniqueName)
        return isValid
      }
    },
    familyDescriptions: () => {
      if (userMetaData.hasOwnProperty('familyDescriptions') && Object.keys(userMetaData.familyDescriptions[0]).length > 0) {
        const isValid = !Misc.validateScriptRegex(JSON.stringify(userMetaData.familyDescriptions[0].description))
        return isValid
      }
    },
    customPackagesName: () => {
      if (userMetaData.hasOwnProperty('packages') && Array.isArray(userMetaData.packages) && userMetaData.packages.length > 0) {
        const customPack = userMetaData.packages.filter(item => item.packageType === 'customPackage')
        const isValid = customPack.some(item => !Misc.validateScriptRegex(item.name))
        return isValid
      }
    },
    partNumbers: () => {
      if (userMetaData.hasOwnProperty('packages') && Array.isArray(userMetaData.packages) && userMetaData.packages.length > 0) {
        const isValid = userMetaData.packages.some(item => !Misc.validateScriptRegex(item.externalSku))
        return isValid
      }
    },
    tags: () => {
      if (userMetaData.hasOwnProperty('tags') && Array.isArray(userMetaData.tags) && userMetaData.tags.length > 0) {
        const isValid = userMetaData.tags.some(item => !Misc.validateScriptRegex(item.name))
        return isValid
      }
    },
    descriptionSupportNote: () => {
      if (description.length > 0) {
        const isValid = !Misc.validateScriptRegex(description)
        return isValid
      }
    }
  }
  const validatorArrays = Object.values(validator).map(f => f())
  return validatorArrays.some(item => item)
}
export {
  validatSubmissionJSON
}
